export const filterCaseInsensitive = (filter, row) => {
  const id = filter.pivotId || filter.id;

  return row[id] !== undefined && row[id] !== null
    ? String(String(row[id]).toLowerCase()).includes(filter.value.toLowerCase())
    : false;
};
